/**
 * 멤버 접근 중지 여부 (DB CHAR 패딩·JSON 키 차이 대응)
 * @param {object|null|undefined} member
 * @returns {boolean}
 */
export function isAllianceMemberAccessSuspended(member) {
  if (!member || typeof member !== 'object') return false;
  const raw = member.accessSuspendedYn ?? member.access_suspended_yn;
  if (raw === true || raw === 1) return true;
  return String(raw ?? '').trim().toUpperCase() === 'Y';
}

/**
 * 방장·본인·비수락 멤버는 접근 일시 중지 UI 제외
 */
export function isAllianceMemberSuspendEditable(member, { canManageAll, currentUserUid }) {
  if (!canManageAll) return false;
  const status = String(member?.joinStatusCd || '').toUpperCase();
  if (status !== 'ACCEPTED') return false;
  if (member?.role === 'Consortium Owner') return false;
  if (currentUserUid != null && String(currentUserUid) === String(member?.userUid)) return false;
  return true;
}
